















import Vue from 'vue';
import { VBTooltip } from 'bootstrap-vue';

import { ProfileIcon } from 'zenComponents';

import { renderComponent } from '@/utils/render';

import { Person } from './types';

// TODO:
// Duplicated code (although slightly different), ask product if we should
// add pics app-wide or what, like in listing presenters. However, we need to
// somehow distinguish between people and groups there as well.
function getTooltipTitle(person: Person): string {
  const profileIconHtml = renderComponent(ProfileIcon, { model: person });

  if (person.email && person.role) {
    const name: string = person.name ? person.name : '';
    return `
      <div class="row d-flex pr-2 pl-2">
        <div class="column pl-2 pr-0 mt-1 bigger-icon">
          ${profileIconHtml}
        </div>
        <div class="column py-2 pl-1 pr-2">
          <h1 class="info-tooltip--title">${name}</h1>
          <p class="info-tooltip--code">${person.email}</p>
          <p class="info-tooltip--role">${person.role}</p>
        </div>
      </div>
    `;
  }
  return '';
}
function getTooltipOptions(person: Person) {
  if (person.email && person.role) {
    return {
      title: getTooltipTitle(person),
      variant: 'info',
      position: 'absolute',
      html: true,
      template: `<div class="info-tooltip" role="tooltip">
          <div class="tooltip-inner"></div>
        </div>`,
      offset: '0,5',
    };
  }
  return {};
}

export default Vue.extend({
  name: 'PeopleProfilePics',
  components: {
    ProfileIcon,
  },
  directives: {
    BTooltip: VBTooltip,
  },
  props: {
    people: {
      type: Array as () => Person[],
      required: true,
    },
  },
  methods: {
    getTooltipOptions,
  },
});
